export default "__VITE_ASSET__BAVJbjq8__"